// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yazio-article-category[data-v-22ce1092]{border:1px solid #e2e5ed}.yazio-article-image[data-v-22ce1092]{height:170px}@media (min-width:640px){.yazio-article-image[data-v-22ce1092]{width:175px;height:auto}.yazio-article-image.slider[data-v-22ce1092]{width:497px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
